import { ArrowRight } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import Reveal from "@/components/Reveal";
import Seo from "@/components/Seo";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLang } from "@/i18n";

const Faq = () => {
  const { t } = useLang();

  return (
    <div className="min-h-screen bg-bone font-sans text-ink antialiased">
      <Seo title={t.seo.faq.title} description={t.seo.faq.description} />
      <Header />
      <main className="pt-[210px] md:pt-[240px]">
        <section className="mx-auto max-w-4xl px-6 md:px-12" data-testid="faq-section">
          <Reveal className="text-center">
            <p className="text-xs font-semibold uppercase tracking-[0.28em] text-clay">{t.faq.overline}</p>
            <h1 data-testid="faq-heading" className="mt-6 font-serif text-5xl leading-[1.05] tracking-tight text-ink sm:text-6xl">
              {t.faq.h1a} <em className="italic text-clay">{t.faq.h1b}</em>
            </h1>
          </Reveal>
          <Reveal delay={0.15}>
            <Accordion type="single" collapsible data-testid="faq-accordion" className="mt-14 border-t border-ink/10">
              {t.faq.items.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-ink/10">
                  <AccordionTrigger data-testid={`faq-q-${i + 1}`} className="py-7 text-start font-serif text-xl tracking-tight text-ink hover:text-clay hover:no-underline md:text-2xl">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="pb-7 text-base leading-relaxed text-ink/60">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
          <Reveal delay={0.2} className="mt-12 text-center">
            <a href="/contact" data-testid="faq-contact-cta" className="group inline-flex items-center gap-3 rounded-full bg-ink px-8 py-4 text-xs font-semibold uppercase tracking-[0.14em] text-bone transition-colors duration-300 hover:bg-clay">
              {t.faq.cta}
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 rtl:rotate-180" />
            </a>
          </Reveal>
        </section>
        <div className="h-24 md:h-32" />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
};

export default Faq;
